import React from 'react';  // eslint-disable-line

const Clock = () => {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Post-Container-App" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                <g id="03b-messages-addnew-schedule-date" transform="translate(-856.000000, -599.000000)" stroke="#304FFE" strokeWidth="0.888888889">
                    <g id="Msg-Modal-3">
                        <g id="modal" transform="translate(406.000000, 132.000000)">
                            <g id="Radio-Button-Group-/-Standard-/-Stacked" transform="translate(35.000000, 372.000000)">
                                <g id="Input-/-Basic-/-MD-/-Icon-Left-/-Active-" transform="translate(401.000000, 81.000000)">
                                    <g id="time-3-outline-24" transform="translate(15.000000, 15.000000)">
                                        <circle id="Oval" cx="8" cy="8" r="7.65217391" />
                                        <polyline id="Shape" points="8 3.82608696 8 8 12.173913 8" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Clock;
